export default __webpack_public_path__ + "static/media/logo1.299b5dd6.png";